import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "content"]
  static classes = ["active"]

  connect () {
    this.popstateHandler = this.popstate.bind(this)
    window.addEventListener("popstate", this.popstateHandler)
  }

  disconnect () {
    window.removeEventListener("popstate", this.popstateHandler)
  }

  select (event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return

    event.preventDefault()

    const trigger = event.currentTarget
    const src = trigger.dataset.src
    if (!src) return

    const tabLink = this.tabLinkFor(trigger) || trigger
    this.activate(tabLink)
    this.load(src)

    const url = tabLink.href || trigger.href
    if (url && window.location.href !== url) {
      history.pushState({ tabsFrame: src }, "", url)
    }
  }

  popstate () {
    const link = this.tabLinkFor({ pathname: window.location.pathname })
    if (!link) return

    this.activate(link)
    this.load(link.dataset.src)
  }

  tabLinkFor (element) {
    return this.linkTargets.find((item) => item.pathname === element.pathname)
  }

  load (src) {
    if (!src || !this.hasContentTarget) return
    if (this.contentTarget.getAttribute("src") === src) return

    this.contentTarget.src = src
  }

  activate (link) {
    this.linkTargets.forEach((item) => {
      const active = item === link
      item.classList.toggle(this.activeCssClass, active)

      if (active) {
        item.setAttribute("aria-current", "page")
      } else {
        item.removeAttribute("aria-current")
      }
    })
  }

  get activeCssClass () {
    return this.hasActiveClass ? this.activeClass : "is-active"
  }
}
